<template>
    <div class="container">
        <h1>Delete survey?</h1>
        <button @click="confirm()" style="background-color: #dc3545; margin-right: 2rem;">
            <h2>Yes</h2>
        </button>
        <button @click="this.$router.push('/manage')">
            <h2>No</h2>
        </button>
    </div>
</template>

<script>
import axios from "axios";
import { baseurl } from "../api";
import accountStore from '../accountStore';
export default {
    methods: {
        confirm() {
            axios.post(baseurl + "deletesurvey", { code: this.$route.params.code, p: accountStore.passcode }).then((r) => {
                if (r.data.success) {
                    this.$router.push("/manage");
                    return;
                }
            });
        },
    },
    mounted() {
        if (!accountStore.verified) {
            this.$router.push("/admin");
        }
    },
    name: "Delete",
};
</script>

<style scoped>
.container {
    margin-bottom: 2rem;
}

input {
    border: 1px solid #555555;
    border-radius: 1rem;
    padding: 1rem 1rem;
    margin: 0 1rem;
    font-size: 1rem;
    font-weight: bold;
    height: 100%;
}

.errored {
    border: 1px solid #ff0000;
}

.errored:focus {
    outline-color: #ff0000;
}

button {
    background-color: #007bff;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
}

button>h2 {
    color: #ffffff;
    margin: 0.8rem 1rem;
}

.inputrow {
    display: flex;
    align-items: center;
}

h5 {
    text-align: left;
    margin: 0.3rem 1.7rem;
    color: #c70000;
    visibility: hidden;
}

.shown {
    visibility: visible;
}
</style>
